import { Play, Pause, SkipBack, Loader2 } from "lucide-react";

const SPEEDS = [1, 2, 4, 8];

const fmtClock = (ms) => (ms ? new Date(ms).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "--:--:--");

export function FleetReplayBar({ date, onDate, start, end, cursor, onCursor, playing, onTogglePlay, speed, onSpeed, loading, truckCount }) {
  const hasData = Number.isFinite(start) && Number.isFinite(end) && end > start;
  return (
    <div className="card-industrial px-4 py-3 flex flex-col gap-3" data-testid="fleet-replay-bar">
      <div className="flex items-center gap-3 flex-wrap">
        <span className="label-tag">REPLAY</span>
        <input
          type="date"
          value={date}
          onChange={(e) => onDate(e.target.value)}
          data-testid="replay-date"
          className="bg-surface border border-industrial px-2 py-1 mono text-xs text-ink focus:border-primary-orange outline-none"
        />
        <button
          type="button"
          onClick={() => onCursor(start)}
          disabled={!hasData}
          data-testid="replay-restart"
          className="inline-flex items-center justify-center w-8 h-8 border border-industrial bg-surface text-ink hover:border-primary-orange disabled:opacity-40 transition"
          title="Back to start"
        >
          <SkipBack className="w-4 h-4" />
        </button>
        <button
          type="button"
          onClick={onTogglePlay}
          disabled={!hasData}
          data-testid="replay-play"
          className="inline-flex items-center justify-center w-10 h-8 border border-primary-orange bg-primary-orange/10 text-primary-orange hover:bg-primary-orange/20 disabled:opacity-40 transition"
          title={playing ? "Pause" : "Play"}
        >
          {playing ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
        </button>
        <div className="flex items-center gap-1" data-testid="replay-speeds">
          {SPEEDS.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => onSpeed(s)}
              data-testid={`replay-speed-${s}`}
              className={`mono text-[10px] font-bold px-2 py-1 border transition ${speed === s ? "border-primary-orange text-primary-orange bg-primary-orange/10" : "border-industrial text-muted-industrial hover:text-ink"}`}
            >
              {s}×
            </button>
          ))}
        </div>
        <div className="mono text-sm font-bold text-primary-orange ml-auto tabular-nums" data-testid="replay-clock">
          {loading ? <Loader2 className="w-4 h-4 animate-spin inline" /> : fmtClock(cursor)}
        </div>
      </div>
      <input
        type="range"
        min={hasData ? start : 0}
        max={hasData ? end : 1}
        value={hasData ? cursor : 0}
        step={1000}
        disabled={!hasData}
        onChange={(e) => onCursor(Number(e.target.value))}
        data-testid="replay-slider"
        className="w-full accent-[#F57C00] disabled:opacity-40"
      />
      <div className="flex items-center justify-between mono text-[10px] text-muted-industrial">
        <span>{fmtClock(start)}</span>
        <span data-testid="replay-truck-count">
          {loading ? "loading history…" : hasData ? `${truckCount} truck${truckCount === 1 ? "" : "s"} with real GPS this day` : "No GPS history for this day (simulated trucks aren't recorded)"}
        </span>
        <span>{fmtClock(end)}</span>
      </div>
    </div>
  );
}
